import React from 'react';

const Section = ({ n, title, children }) => (
  <div className="text-left mt-8">
    <div className="font-mono-r text-[10px] tracking-[0.4em] uppercase opacity-60">§ {n}</div>
    <h3 className="font-display text-3xl mt-1">{title}</h3>
    <div className="font-mono-r text-sm mt-3 leading-relaxed opacity-90 space-y-3">
      {children}
    </div>
  </div>
);

export default function Privacy() {
  return (
    <section className="w-full flex flex-col items-center text-center fade-up">
      <div className="text-[10px] font-mono-r tracking-[0.5em] uppercase opacity-70">
        ::  Legal  ::
      </div>
      <h1 className="font-display text-6xl md:text-8xl mt-4">PRIVACY</h1>
      <p className="font-mono-r text-xs tracking-[0.25em] uppercase opacity-70 mt-3">
        Last updated · 11 February 2026
      </p>
      <div className="ascii-divider my-10">─  ─  ─  ─  ─</div>

      <div className="max-w-2xl w-full">
        <Section n="01" title="Who We Are">
          <p>
            OSO London is an independent internet radio station broadcasting
            from London, United Kingdom. References to &ldquo;we&rdquo;, &ldquo;us&rdquo; or &ldquo;our&rdquo;
            mean OSO London.
          </p>
        </Section>

        <Section n="02" title="What We Collect">
          <p>
            <strong>Listening:</strong> when you stream the radio, the audio
            host (AsuraHosting) receives standard server logs — your IP
            address, the time you connected and the audio player you used.
          </p>
          <p>
            <strong>Contact form:</strong> if you write to us we receive the
            name, email address and message you provide.
          </p>
          <p>
            <strong>Alexa skill:</strong> when you say &ldquo;Alexa, play OSO
            London&rdquo; the Alexa Skills Kit sends our endpoint an anonymised
            user identifier and the intent you triggered. We do not store
            it. Amazon&apos;s own privacy policy governs the device side.
          </p>
          <p>
            <strong>Analytics:</strong> we use lightweight, cookie-less
            traffic analytics to count visits to each page. No personal
            profile is built.
          </p>
        </Section>

        <Section n="03" title="What We Don't Do">
          <p>
            We do not sell personal data, share it with advertisers, run
            third-party ad trackers, or build behavioural profiles. We do
            not require an account to listen.
          </p>
        </Section>

        <Section n="04" title="Your Rights (UK GDPR)">
          <p>
            You can ask us to access, correct or delete any personal data
            we hold about you by emailing{' '}
            <a className="underline" href="mailto:info@osolondon.com">info@osolondon.com</a>.
            We will respond within 30 days. You also have the right to
            lodge a complaint with the UK Information Commissioner&apos;s
            Office (<a className="underline" href="https://ico.org.uk" target="_blank" rel="noreferrer">ico.org.uk</a>).
          </p>
        </Section>

        <Section n="05" title="Children">
          <p>
            The OSO London Alexa skill and website are not directed at
            children under 13 and we do not knowingly collect data from
            them.
          </p>
        </Section>

        <Section n="06" title="Changes">
          <p>
            We may update this policy occasionally. Material changes will
            be announced on this page and the &ldquo;Last updated&rdquo; date above
            will change.
          </p>
        </Section>

        <Section n="07" title="Contact">
          <p>
            Questions? <a className="underline" href="mailto:info@osolondon.com">info@osolondon.com</a>
          </p>
        </Section>
      </div>
    </section>
  );
}
